<template>
	<div class="jbxx">
		<div class="g-ypxx">
			<form>
				<p>
					<span class="ypxx-left">中文名</span>
					<span class="ypxx-right"><input v-model="name" type="text"></span>
					<div class=" clearfix"></div>
				</p>
				<p>
					<span class="ypxx-left">英文名</span>
					<span class="ypxx-right"><input v-model="english_name" type="text">
						<font style='color:#999;margin-left:10px;'></font>
					</span>
					<div class=" clearfix"></div>
				</p>
				<p>
					<span class="ypxx-left">性别</span>
					<span class="ypxx-right">
						<RadioGroup v-model="sex">

							<Radio label="1">男</Radio>
							<Radio label="2">女</Radio>
							<Radio label="3">保密</Radio>
						</RadioGroup>
					</span>
					<div class=" clearfix"></div>
				</p>
				<p>
					<span class="ypxx-left">民族</span>
					<span class="ypxx-right">
						<el-select v-model="nation" clearable placeholder="请选择">
							<el-option v-for="item in nations" :key="item.value" :label="item.label" :value="item.value">
							</el-option>
						</el-select>
					</span>

					<div class=" clearfix"></div>
				</p>
				<p>
					<span class="ypxx-left">身高</span>
					<span class="ypxx-right"><input v-model="stature" type="text">

					</span>

					<div class=" clearfix"></div>
				</p>
				<p>
					<span class="ypxx-left">体重</span>
					<span class="ypxx-right"><input v-model="weight" type="text">

					</span>

					<div class=" clearfix"></div>
				</p>
				<p>
					<span class="ypxx-left">三围</span>
					<span class="ypxx-right"><input v-model="bwh" type="text">

					</span>

					<div class=" clearfix"></div>
				</p>
				<p>
					<span class="ypxx-left">血型</span>
					<span class="ypxx-right">
						<RadioGroup v-model="blood">

							<Radio label="1">A</Radio>
							<Radio label="2">B</Radio>
							<Radio label="3">AB</Radio>
							<Radio label="4">O</Radio>
						</RadioGroup>
					</span>
					<div class=" clearfix"></div>
				</p>
				<p>
					<span class="ypxx-left">星座</span>
					<span class="ypxx-right">
						<RadioGroup v-model="constellation">

							<Radio label="1">白羊座</Radio>
							<Radio label="2">金牛座</Radio>
							<Radio label="3">双子座</Radio>
							<Radio label="4">巨蟹座</Radio>
							<Radio label="5">狮子座</Radio>
							<Radio label="6">处女座</Radio>
							<Radio label="7">天秤座</Radio>
							<Radio label="8">天蝎座</Radio>
							<Radio label="9">射手座</Radio>
							<Radio label="10">摩羯座</Radio>
							<Radio label="11">水瓶座</Radio>
							<Radio label="12">双鱼座</Radio>
						</RadioGroup>
					</span>
					<div class=" clearfix"></div>
				</p>
				<p>
					<span class="ypxx-left">出生地</span>
					<span class="ypxx-right"><input v-model="place" type="text">

					</span>

					<div class=" clearfix"></div>
				</p>

				<p>
					<span class="ypxx-left">出生年月</span>
					<span class="ypxx-right">
						<el-date-picker v-model="bom_time" type="date" placeholder="       选择日期" value-format="yyyy-MM-dd">
						</el-date-picker>
					</span>

					<div class=" clearfix"></div>
				</p>
				<p>
					<span class="ypxx-left">毕业院校</span>
					<span class="ypxx-right"><input v-model="school" type="text"></span>
					<div class=" clearfix"></div>
				</p>
				<p>
					<span class="ypxx-left">经纪公司</span>
					<span class="ypxx-right"><input v-model="manage" type="text"></span>
					<div class=" clearfix"></div>
				</p>
				<p>
					<span class="ypxx-left">联系方式</span>
					<span class="ypxx-right"><input v-model="agent_contact" type="text"></span>
					<div class=" clearfix"></div>
				</p>
				<p>
					<span class="ypxx-left">qq号</span>
					<span class="ypxx-right"><input v-model="qq_number" type="text"></span>
					<div class=" clearfix"></div>
				</p>
				<p>
					<span class="ypxx-left">微信号</span>
					<span class="ypxx-right"><input v-model="wechat" type="text"></span>
					<div class=" clearfix"></div>
				</p>
				<div class="border-line"></div>
				<p>
					<span class="ypxx-left">脸型</span>
					<span class="ypxx-right">
						<RadioGroup v-model="feature">
							<Radio label="1">鹅蛋脸</Radio>
							<Radio label="2">菱形脸</Radio>
							<Radio label="3">国字脸</Radio>
							<Radio label="4">瓜子脸</Radio>
							<Radio label="5">圆形脸</Radio>
							<Radio label="6">方形脸</Radio>
							<Radio label="7">三角脸</Radio>
						</RadioGroup>
					</span>
					<div class=" clearfix"></div>
				</p>
				<p>
					<span class="ypxx-left">职业</span>
					<span class="ypxx-right">
						<RadioGroup v-model="vocation">

							<Radio label="1">演员</Radio>
							<Radio label="2">模特</Radio>
							<Radio label="3">歌手</Radio>
							<Radio label="4">导演</Radio>
							<Radio label="5">副导演</Radio>
							<Radio label="6">编剧</Radio>
							<Radio label="7">制片</Radio>
							<Radio label="8">主持人</Radio>

						</RadioGroup>
					</span>
					<div class=" clearfix"></div>
				</p>
				<p>
					<span class="ypxx-left">特长</span>
					<span class="ypxx-right">
						<el-checkbox-group v-model="tag" :min="1" :max="3">
							<el-checkbox v-for="item in tags" :label="item.key" :key="item.value">{{item.value}}</el-checkbox>
						</el-checkbox-group>
					</span>
					<div class=" clearfix"></div>
				</p>
				<p>
					<span class="ypxx-left">标签</span>
					<span class="ypxx-right">
						<el-checkbox-group v-model="label" :min="1" :max="3">
							<el-checkbox v-for="item in labels" :label="item.key" :key="item.value">{{item.value}}</el-checkbox>
						</el-checkbox-group>
					</span>
					<div class=" clearfix"></div>
				</p>
				<div class="border-line"></div>
				<p>
					<span class="ypxx-left">简介</span>
					<span class="ypxx-right">
						<textarea v-model="detailed" class="g-wd-txt"></textarea>
						<span style='vertical-align: top;margin-left: 10px;color: #999;'>限300字以内</span>
					</span>
					<div class="clearfix"></div>
				</p>
				<p>
					<span class="ypxx-left">座右铭</span>
					<span class="ypxx-right"><input v-model="signature" type="text">
						<font style='color:#999;margin-left:10px;'></font>
					</span>
					<div class=" clearfix"></div>
				</p>
				<p>
					<span class="ypxx-left">个人封面</span>
					<span class="ypxx-right">
						<div class="imgfm" style="float: left;">
							<img :src="imgsrc" width="250" height="350">

						</div>
						<div class="float-right">
							<div class="line" style="">
								<div class="cropper-content" style="">
									<div class="cropper">
										<vueCropper ref="cropper" :img="option.img" :outputSize="option.size" :outputType="option.outputType" :info="true"
										 :full="option.full" :canMove="option.canMove" :canMoveBox="option.canMoveBox" :original="option.original"
										 :autoCrop="option.autoCrop" :autoCropWidth="option.autoCropWidth" :autoCropHeight="option.autoCropHeight"
										 :fixedBox="option.fixedBox" @realTime="realTime" @imgLoad="imgLoad"></vueCropper>
									</div>
								</div>
							</div>
							<center>
								<div class="crop-btn">
									<label class="crop-select-btn" for="uploads">选择</label>
									<input type="file" id="uploads" :value="imgFile" style="position:absolute; clip:rect(0 0 0 0);" accept="image/png, image/jpeg, image/gif, image/jpg"
									 @change="uploadImg($event, 1)">
									<input type="button" class="oper" value="+" title="放大" @click="changeScale(1)">
									<input type="button" class="oper" value="-" title="缩小" @click="changeScale(-1)">
									<label class="crop-select-btn" @click="finish('blob')">裁剪</label>

								</div>
							</center>
						</div>
						<div class="clearfix"></div>
					</span>

					<div class=" clearfix"></div>
				</p>
				<center><input @click="uploadinfor" type="submit" class="g-btn" value="确定修改"></center>
			</form>

		</div>
	</div>
</template>

<script>
	import storage from '../../../storage/storage.js'
	import Axios from 'axios'
	export default {
		data() {
			return {
				list: [],
				crap: false,
				previews: {},
				option: {
					img: '',
					outputSize: 0.5, //剪切后的图片质量（0.1-1）
					full: false, //输出原图比例截图 props名full
					outputType: 'jpeg',
					canMove: true, //能否拖动图片
					original: false, //是否显示原始宽高
					canMoveBox: false, //能否拖动截图框
					autoCrop: true, //是否自动生成截图框
					autoCropWidth: 250,
					autoCropHeight: 350,
					fixedBox: true // 固定大小 禁止改变截图框大小
				},
				fileName: '', //本机文件地址
				imgFile: '',
				uploadImgRelaPath: '', //上传后的图片的地址（不带服务器域名）
				tag: storage.get('m_tag'),
				label: storage.get('m_label'),
				name: storage.get('name'), //姓名
				imgsrc: storage.get('imgsrc'),
				english_name: storage.get('english_name'), //英文名
				sex: storage.get('sex'), //性别
				blood: storage.get('blood'), //血型
				nation: storage.get('nation'), //民族
				stature: storage.get('stature'), //身高
				vocation: storage.get('vocation'), //职业
				weight: storage.get('weight'), //体重
				feature: storage.get('feature'), //脸型
				bom_time: storage.get('bom_time'), //出生日期
				bwh: storage.get('bwh'), //三围
				picture: '',
				school: storage.get('school'), //毕业院校
				detailed: storage.get('detailed'), //简介
				signature: storage.get('signature'), //座右铭
				constellation: storage.get('constellation'), //星座
				place: storage.get('place'),
				agent_contact: storage.get('agent_contact'),
				qq_number: storage.get('qq_number'),
				wechat: storage.get('wechat'),
				manage:storage.get('manage'),
				nations: [{
						value: '1',
						label: '汉族'
					}, {
						value: '2',
						label: '满族'
					},
					{
						value: '3',
						label: '壮族'
					}, {
						value: '4',
						label: '回族'
					},
					{
						value: '5',
						label: '苗族'
					}, {
						value: '6',
						label: '维吾尔族'
					},
					{
						value: '7',
						label: '土家族'
					}, {
						value: '8',
						label: '彝族'
					},
					{
						value: '9',
						label: '蒙古族'
					}, {
						value: '10',
						label: '藏族'
					},
					{
						value: '11',
						label: '布依族'
					}, {
						value: '12',
						label: '侗族'
					},
					{
						value: '13',
						label: '瑶族'
					}, {
						value: '14',
						label: '朝鲜族'
					},
					{
						value: '15',
						label: '白族'
					}, {
						value: '16',
						label: '哈尼族'
					},
					{
						value: '17',
						label: '哈萨克族'
					}, {
						value: '18',
						label: '黎族'
					},
					{
						value: '19',
						label: '傣族'
					}, {
						value: '20',
						label: '畲族'
					},
					{
						value: '21',
						label: '傈僳族'
					}, {
						value: '22',
						label: '仡佬族'
					},
					{
						value: '23',
						label: '东乡族'
					}, {
						value: '24',
						label: '高山族'
					},
					{
						value: '25',
						label: '拉祜族'
					}, {
						value: '26',
						label: '水族'
					},
					{
						value: '27',
						label: '佤族'
					}, {
						value: '28',
						label: '纳西族'
					},
					{
						value: '29',
						label: '羌族'
					},
					{
						value: '30',
						label: '土族'
					},
					{
						value: '31',
						label: '仫佬族'
					},
					{
						value: '32',
						label: '锡伯族'
					},
					{
						value: '33',
						label: '柯尔克孜族'
					},
					{
						value: '34',
						label: '达斡尔族'
					},
					{
						value: '35',
						label: '景颇族'
					},
					{
						value: '36',
						label: '毛南族'
					},
					{
						value: '37',
						label: '撒拉族'
					},
					{
						value: '38',
						label: '塔吉克族'
					},
					{
						value: '39',
						label: '阿昌族'
					},
					{
						value: '40',
						label: '普米族'
					},
					{
						value: '41',
						label: '鄂温克族'
					}, {
						value: '42',
						label: '怒族'
					}, {
						value: '43',
						label: '京族'
					}, {
						value: '44',
						label: '基诺族'
					}, {
						value: '45',
						label: '德昂族'
					}, {
						value: '46',
						label: '保安族'
					}, {
						value: '47',
						label: '俄罗斯族'
					}, {
						value: '48',
						label: '裕固族'
					}, {
						value: '49',
						label: '乌兹别克族'
					}, {
						value: '50',
						label: '门巴族'
					},
					{
						value: '51',
						label: '鄂伦春族'
					},
					{
						value: '52',
						label: '独龙族'
					},
					{
						value: '53',
						label: '塔塔尔族'
					},
					{
						value: '54',
						label: '赫哲族'
					},
					{
						value: '55',
						label: '珞巴族'
					},
					{
						value: '56',
						label: '布朗族'
					},
				],
				tags: [{
						key: 1,
						value: '唱歌'
					},
					{
						key: 2,
						value: '跳舞'
					},
					{
						key: 3,
						value: '武术'
					},
					{
						key: 4,
						value: '骑马'
					},
					{
						key: 5,
						value: '乐器'
					},
					{
						key: 6,
						value: '方言'
					},
					{
						key: 7,
						value: '外语'
					},
					{
						key: 8,
						value: '主持'
					},
					{
						key: 9,
						value: '驾驶'
					},
					{
						key: 10,
						value: '书画'
					},

				],
				labels: [{
						key: 11,
						value: '特型'
					},
					{
						key: 12,
						value: '朴实'
					},
					{
						key: 13,
						value: '谐星'
					},
					{
						key: 14,
						value: '胖咖'
					},
					{
						key: 15,
						value: '丑咖'
					},
					{
						key: 16,
						value: '痞气'
					},
					{
						key: 17,
						value: '反派'
					},
					{
						key: 18,
						value: '中性'
					},
					{
						key: 19,
						value: '妩媚'
					},
					{
						key: 20,
						value: '性感'
					},
					{
						key: 21,
						value: '知性'
					},
					{
						key: 22,
						value: '御姐'
					},
					{
						key: 23,
						value: '帅气'
					},
					{
						key: 24,
						value: '大叔'
					},
					{
						key: 25,
						value: '霸道'
					},
					{
						key: 26,
						value: '成熟'
					},
					{
						key: 27,
						value: '型男'
					},
					{
						key: 28,
						value: '阳光'
					},
					{
						key: 29,
						value: '暖男'
					},
					{
						key: 30,
						value: '老戏骨'
					},
					{
						key: 31,
						value: '戏剧性'
					},
					{
						key: 32,
						value: '硬汉型'
					},
					{
						key: 33,
						value: '文艺范'
					},
				],
			}
		},

		methods: {
			changeScale(num) {

				num = num || 1;
				this.$refs.cropper.changeScale(num);
			},

			finish(type) {

				let _this = this;
				// 输出
				if (type === 'blob') {
					this.$refs.cropper.getCropBlob((data) => {
						let img = window.URL.createObjectURL(data)
						this.model = true;
						this.modelSrc = img;
						//将获取到的裁剪后图片信息转成base64格式
						var image = new Image();
						var vm = this
						var reader = new FileReader();
						reader.readAsDataURL(data);
						reader.onload = function(e) {
							vm.imgsrc = e.target.result //将base64信息赋值给需要显示图片的字段
						}
					})
				} else {
					this.$refs.cropper.getCropData((data) => {
						this.model = true;
						this.modelSrc = data;
					})
				}
			},
			upinfor() {
				 //获取到裁剪后的图片base64字符串
			},
			// 实时预览函数
			realTime(data) {

				this.previews = data
			},
			//选择本地图片
			uploadImg(e, num) {
				var _this = this;
				var file = e.target.files[0]
				_this.fileName = file.name;
				if (!/\.(gif|jpg|jpeg|png|bmp|GIF|JPG|PNG)$/.test(e.target.value)) {
					alert('图片类型必须是.gif,jpeg,jpg,png,bmp中的一种')
					return false
				}
				var reader = new FileReader();
				reader.onload = (e) => {
					let data;
					if (typeof e.target.result === 'object') {
						// 把Array Buffer转化为blob 如果是base64不需要
						data = window.URL.createObjectURL(new Blob([e.target.result]))
					} else {
						data = e.target.result
					}
					if (num === 1) {
						_this.option.img = data
					} else if (num === 2) {
						_this.example2.img = data
					}
				}
				reader.readAsArrayBuffer(file);

			},
			imgLoad(msg) {

			},

			uploadinfor(event) {
				var api = 'https://api.yopoo.cn/api/centre/editinfo'
				//定义form表单的格式并实例化
				event.preventDefault();
				let formData = new FormData();
				//向form表单中插入数据
				formData.append('name', this.name); //姓名
				formData.append('english_name', this.english_name); //英文名
				formData.append('sex', this.sex); //性别
				formData.append('blood', this.blood); //血型
				formData.append('nation', this.nation); //民族
				formData.append('stature', this.stature); //身高
				formData.append('vocation', this.vocation); //职业
				formData.append('weight', this.weight); //体重
				formData.append('feature', this.feature); //脸型
				formData.append('bom_time', this.bom_time); //出生日期
				formData.append('bwh', this.bwh); //三围
				formData.append('picture', this.imgsrc); //封面图片
				formData.append('school', this.school); //毕业院校
				formData.append('detailed', this.detailed); //简介
				formData.append('tag', this.tag); //特长
				formData.append('label', this.label); //标签
				formData.append('signature', this.signature); //座右铭
				formData.append('constellation', this.constellation); //星座
				formData.append('place', this.place); //籍贯
				formData.append('agent_contact', this.agent_contact); //联系方式
				formData.append('qq_number', this.qq_number); //qq号
				formData.append('wechat', this.wechat); //微信号
				formData.append('manage', this.manage); //微信号

				let config = {
					headers: {
						//定义form表单的格式头
						'Content-Type': 'multipart/form-data'
					}
				}
				//向后台提交数据，并接收返回值
				Axios.post(api, formData, config).then((res) => {
					if (res.data.code == '200') {
						// console.log(res)
						//获取后台返回的uid，并存储用作后续提交的绑定信息
						// console.log(res.data.uid)
						this.uid = storage.set('uid', res.data.uid)
						//定时器控制跳转下一个路由目标
						this.$message({
							message: res.data.msg,
							type: 'success',
							center: true
						});
						setTimeout(() => {
							location.reload()
						}, 1000);
					}
					if (res.data.code == '202') {
						//如果获取后台返回的错误码给用户提示，后期加入插件优化alert弹窗效果
						this.$message({
							message: res.data.msg,
							type: 'error',
							center: true
						});
					}
				}).catch((res) => {

				})
			},

		},

	}
</script>

<style scoped lang="less">
	.info {
		width: 720px;
		margin: 0 auto;

		.oper-dv {
			height: 20px;
			text-align: right;
			margin-right: 100px;

			a {
				font-weight: 500;

				&:last-child {
					margin-left: 30px;
				}
			}
		}

		.info-item {
			margin-top: 15px;

			label {
				display: inline-block;
				width: 100px;
				text-align: right;
			}

			.sel-img-dv {
				position: relative;

				.sel-file {
					position: absolute;
					width: 90px;
					height: 30px;
					opacity: 0;
					cursor: pointer;
					z-index: 2;
				}

				.sel-btn {
					position: absolute;
					cursor: pointer;
					z-index: 1;
				}
			}
		}
	}

	.cropper-content {
		// 		display: flex;
		// 		display: -webkit-flex;
		// 		justify-content: flex-end;
		// 		-webkit-justify-content: flex-end;

		.cropper {
			width: 250px;
			height: 350px;
		}

		.show-preview {
			flex: 1;
			-webkit-flex: 1;
			display: flex;
			display: -webkit-flex;
			justify-content: center;
			-webkit-justify-content: center;

			.preview {
				overflow: hidden;
				border-radius: 50%;
				border: 1px solid #cccccc;
				background: #cccccc;
				margin-left: 40px;
			}
		}
	}

	.cropper-content .show-preview .preview {
		margin-left: 0;
	}
</style>



// WEBPACK FOOTER //
// src/components/per_admin/per_modify/M_Jbxx.vue